(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var Facebook = require('../../social/_facebook')();

if (!window.P2A) {
    window.P2A = {};
}
window.P2A.Social = {
    "Facebook": Facebook
};

},{"../../social/_facebook":2}],2:[function(require,module,exports){
'use strict';

module.exports = function () {
    var Facebook = {
        appId: '',
        language: 'EN',
        authInfo: null,
        loginRefreshTried: false,
        $facebookLoginContainer: null,
        loginButton: {
            originalContent: null
        }
    };

    /**
     * Init the Facebook JS API
     * 
     * @param  {[type]} appId  [description]
     * @param  {[type]} onInit [description]
     * @return {[type]}        [description]
     */
    Facebook.init = function (appId, onInit) {

        if (appId) {
            Facebook.setAppId(appId);
        }

        if (Facebook.appId) {

            //If CampaignLanguage is set, use that
            if (window.P2A.CampaignLanguage) {
                Facebook.language = window.P2A.CampaignLanguage;
            }

            Facebook.initFacebookJS(Facebook.language);
            Facebook.fBAsyncInit(Facebook.appId);

            if (typeof onInit === 'function') {
                onInit.call(null, Facebook);
            }
        }
    };

    Facebook.setAppId = function (appId) {
        Facebook.appId = appId;
    };
    Facebook.setAuthInfo = function (authInfo) {
        Facebook.authInfo = authInfo;
    };

    Facebook.resetLoginButton = function () {
        Facebook.hideLoginLoading();
        Facebook.showLoginButton();
    };
    Facebook.displayLoginError = function (message) {
        var errorMessage = '<div class="alert alert-danger facebook-login-error">Facebook error! ' + message + '</div>';
        Facebook.showLoginButton();
        Facebook.displayLoginStatus(errorMessage);
        Facebook.resetLoginButton();
    };
    Facebook.showLoginButton = function () {
        $('.btn-facebook-login').show();
    };
    Facebook.hideLoginButton = function () {
        Facebook.hideLoginLoading();
        $('.btn-facebook-login').hide();
    };
    Facebook.displayLoginStatus = function (message) {
        $('.facebook-login-container .facebook-login-status').html(message);
    };
    Facebook.showLoginLoading = function () {
        Facebook.displayLoginStatus('');
        var $loginButton = $('.btn-facebook-login');
        Facebook.loginButton.originalContent = $loginButton.html();
        $loginButton.width($loginButton.width() + 'px');
        $loginButton.html('<i class="fa fa-spin fa-spinner"></i>');
        $loginButton.prop('disabled', true);
    };
    Facebook.hideLoginLoading = function () {
        var $loginButton = $('.btn-facebook-login');
        $loginButton.width('');
        $loginButton.html(Facebook.loginButton.originalContent);
        $loginButton.prop('disabled', false);
    };

    Facebook.PromptForLogin = function () {
        FB.login(function (response) {
            if (response.authResponse) {
                Facebook.loginReturned(response);
            } else {
                Facebook.resetLoginButton();
            }
        }, {
            scope: 'public_profile,email,user_location',
            return_scopes: true,
            auth_type: 'rerequest'
        });
    };

    Facebook.loginReturned = function (response) {
        Facebook.setAuthInfo(response.authResponse);

        $(Facebook).triggerHandler('loginReturned', [{
            response: response
        }]);

        //Triggers userRetrieved when users info is retrieved
        Facebook.getUserInfo();
    };

    Facebook.refreshLogin = function () {
        //Try once to log the user back in, forcing the sdk to get fresh data from facebook
        //It's possible that they removed our app and didnt refresh the campaign page
        //Or they logged out of Fb in another tab
        //https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus#servers
        if (Facebook.loginRefreshTried !== true) {
            Facebook.loginRefreshTried = true;
            Facebook.checkLoginState(true, true);
            return true;
        } else {
            //Otherwise, we arent going to try to refresh again, this would loop the user
            return false;
        }
    };

    Facebook.SaveLogin = function (loginData) {
        var uri = '/social/login/facebook';
        var params = {
            method: 'POST',
            data: loginData
        };
        var onSuccess = function onSuccess(response) {
            if (response && response.advocateId && typeof setAdvocateId === 'function') {
                setAdvocateId(response.advocateId);
            }
        };
        var onError = function onError(w, t, f) {
            $(Facebook).triggerHandler('saveLogin.failed', [{
                loginData: loginData,
                w: w,
                t: t,
                f: f
            }]);
        };
        window.P2A.Helpers.Ajax.send(uri, params, onSuccess, onError);
    };

    Facebook.getUserInfo = function () {
        FB.api('/me', { fields: 'id,gender,email,first_name,last_name,location,relationship_status' }, function (response) {
            if (response.error) {
                if (Facebook.refreshLogin() === true) {
                    return false;
                } else {
                    //Display an error message
                    Facebook.displayLoginError('Please refresh the page and try again.');
                }
            }

            var user = {
                id: null,
                firstName: null,
                lastName: null,
                gender: null,
                email: null,
                city: null,
                state: null
            };
            if (response.location && response.location.name) {
                //response.location = city,state
                var location = response.location.name.split(',');
                if (location[0]) {
                    user.city = location[0];
                }
                if (location[1]) {
                    user.state = $.trim(location[1]);
                }
            }
            if (response.first_name) {
                user.firstName = response.first_name;
            }
            if (response.last_name) {
                user.lastName = response.last_name;
            }
            if (response.gender) {
                user.gender = response.gender;
            }
            if (response.email) {
                user.email = response.email;
            }
            if (response.id) {
                user.id = response.id;
            }
            $(Facebook).triggerHandler('userRetrieved', [{
                user: user
            }]);
        });
    };

    // This is called with the results from from FB.getLoginStatus().
    Facebook.statusChangeCallback = function (response, logUserIn) {
        //Default to logging the user in if they are logged to fb/our app
        if (typeof logUserIn === 'undefined') {
            logUserIn = true;
        }

        // The response object is returned with a status field that lets the
        // app know the current login status of the person.
        // Full docs on the response object can be found in the documentation
        // for FB.getLoginStatus().
        if (response.status === 'connected' && response.authResponse) {
            // Logged into your app and Facebook.
            if (logUserIn === true) {
                //Check permissions
                //If we have any declined permissions, re-ask for permission
                FB.api('/' + response.authResponse.userID + '/permissions', 'get', { status: 'declined' }, function (declinedResponse) {
                    if (!declinedResponse.data || declinedResponse.data.length) {
                        Facebook.PromptForLogin();
                        return false;
                    } else {
                        Facebook.loginReturned(response);
                        return true;
                    }
                });
            }
        } else if (logUserIn === true) {
            Facebook.PromptForLogin();
        }
    };

    // This function is called when someone finishes with the Login
    // Button.  See the onlogin handler attached to it in the sample
    // code below.
    Facebook.checkLoginState = function (logUserIn, forceRefresh) {
        //Default to logging the user in if they are logged to fb/our app
        if (typeof logUserIn === 'undefined') {
            logUserIn = true;
        }
        //By default, use the cached called
        if (typeof forceRefresh === 'undefined') {
            forceRefresh = false;
        }
        FB.getLoginStatus(function (response) {
            Facebook.statusChangeCallback(response, logUserIn);
        }, forceRefresh);
    };

    Facebook.fBAsyncInit = function (appId) {
        window.fbAsyncInit = function () {
            FB.init({
                appId: appId,
                version: 'v2.5',
                status: true, //Get info about the current user on init
                xfbml: false, //are social plugins on the page?
                cookie: true //Set cookie for the session so server-side code can access it
            });
            //Listen for when our .init comes back - it will contain the users current status
            FB.Event.subscribe('auth.statusChange', function (response) {
                Facebook.statusChangeCallback(response, false);
            });
        };
    };

    Facebook.initFacebookJS = function (language) {
        var localizationMatching = {
            'EN': 'en_US',
            'ES': 'es_LA', //universal Spanish
            'FR': 'fr_FR', //French (France)
            'SV': 'sv_SE', //Swedish
            'NL': 'nl_NL', //Dutch
            'IT': 'it_IT', //Italian
            'PT': 'pt_PT' //Portuguese (Portugal)
        };

        var localization = localizationMatching['EN'];
        if (localizationMatching[language]) {
            localization = localizationMatching[language];
        }
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);js.id = id;
            js.src = "//connect.facebook.net/" + localization + "/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    };

    return Facebook;
};

},{}]},{},[1]);
